module.exports = __webpack_public_path__ + "fonts/2f3c8a2.woff";